<template>
<q-page padding>

  <div class="row">
    <div class="col">
      <q-input v-model="pedido_buscado" filled type="search" hint="numero de pedido" @keyup.enter="getPedido">
        <template v-slot:append>
          <q-icon name="search" />
        </template>
      </q-input>
    </div>
  </div>

  <div class="row">
    <div class="col" v-if="pedido">
      <p class="q-pt-sm"><strong>Pedido:</strong> {{pedido.id}}</p>
      <p><strong>Ref cliente:</strong> {{pedido.codigo_cliente}}</p>
      <p><strong>Fecha:</strong> {{pedido.created_at}}</p>
      <p><strong>Nombre:</strong> {{pedido.nombre}}</p>
      <p><strong>Dirección:</strong> {{pedido.direccion}}</p>
      <p><strong>Localidad:</strong> {{pedido.localidad}}</p>
      <p><strong>CP:</strong> {{pedido.codigo_postal}}</p>
      <p><strong>Provincia:</strong> {{pedido.provincia}}</p>
      <p><strong>Teléfono 1:</strong> {{pedido.telefono1}}</p>
      <p><strong>Teléfono 2:</strong> {{pedido.telefono2}}</p>
      <p><strong>Estado:</strong> {{pedido.estado.nombre}}</p>
      <p><strong>Fecha entrega:</strong> {{pedido.fecha_entrega}}</p>
      <p><strong>Notas:</strong> {{pedido.notas}}</p>
      <p v-for="linea in pedido.lineas" :key="linea.id">
        * {{linea.codigo_copia}}, {{linea.nombre_copia}}, {{linea.unidades}}, {{linea.texto_aux}}
      </p>

      <div class="">
        <upload :empresa_id='pedido.empresa_id' :pedido_id="pedido.id"></upload>
      </div>
      
      <div class="">
        <signature :empresa_id='pedido.empresa_id' :pedido_id="pedido.id"></signature>
      </div>

    </div>
  </div>
  
  <div class="row">
    <div class="col">
      <div v-if="mensaje" class="alert alert-danger" role="alert">
      {{mensaje}}
      </div>
    </div>
  </div>
  
</q-page>
</template>

<script>
import {authHeader} from '@/_helpers/_auth-header';
import axios from 'axios';
import UploadPedidoArchivo from '@/components/UploadPedidoArchivo.vue';
import FirmaDialog from '@/components/FirmaDialog.vue';
import {mapState, mapGetters} from 'vuex';

export default {
  components: {
    'upload': UploadPedidoArchivo,
    'signature': FirmaDialog,
  },
  data() {
    return {
      pedido: null,
      pedido_buscado: '',
      mensaje: ''
    }
  },
  computed: {
    ...mapState(['urlBase']),
    ...mapGetters([])
  },
  methods: {
    getPedido() {
      if (!this.pedido_buscado) {
        return 
      }

      let url = this.urlBase + '/api/v3/pedidos/' + this.pedido_buscado;

      const requestOptions = {
        headers: authHeader(),
      };

      // Via axios
      axios.get(url, requestOptions)
        .then(response => {
            console.log(response.data);
            let result = response.data;
            if(result.data) {
              this.pedido = result.data;
            }
            this.mensaje = '';
            this.pedido_buscado = '';
        })
        .catch(error => {
            console.log(error.response)
            this.pedido = null;
            this.mensaje = 'pedido no encontrado';
            this.pedido_buscado = '';
        });
    },
    
  },
  mounted() {
    // this.textoAlmacenado = localStorage.getItem("textoAlmacenado");
  }
}
</script>

